import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface NotificationPermissionState {
  isModalOpen: boolean;
  hasDeviceToken: boolean;
  permissionStatus: "default" | "granted" | "denied";
}

const initialState: NotificationPermissionState = {
  isModalOpen: false,
  hasDeviceToken: false,
  permissionStatus: "default",
};

export const notificationPermissionSlice = createSlice({
  name: "notificationPermission",
  initialState,
  reducers: {
    setModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
    setHasDeviceToken: (state, action: PayloadAction<boolean>) => {
      state.hasDeviceToken = action.payload;
    },
    setPermissionStatus: (
      state,
      action: PayloadAction<"default" | "granted" | "denied">
    ) => {
      state.permissionStatus = action.payload;
    },
    checkDeviceToken: (state) => {
      const stored = localStorage.getItem("deviceToken");
      state.hasDeviceToken = !!(stored && stored.trim());
      state.permissionStatus = Notification.permission;
    },
  },
});

export const {
  setModalOpen,
  setHasDeviceToken,
  setPermissionStatus,
  checkDeviceToken,
} = notificationPermissionSlice.actions;

export const selectNotificationPermission = (state: RootState) => {
  return state.notificationPermission;
};

export default notificationPermissionSlice.reducer;
